import React, { useEffect } from "react";
import { pdfjs, Document, Page } from "react-pdf";
import styles from "../../BorrowerDetails.module.css";
import { useState } from "react";
// import "./PDFViewer.css";
import pdfStyles from "./PDFViewer.module.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useMediaQuery } from "react-responsive";
import CloseIcon from "@mui/icons-material/Close";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFViewer = ({ url, closeModal }) => {
  const handlePassword = (callback, reason) => {
    const callbackProxy = (password) => {
      if (password === null) {
        const promptWindow = window.open("", "_self");
        promptWindow.close();
        closeModal();
        return;
      }
      callback(password);
    };

    const password = prompt("Enter Password");
    callbackProxy(password);
    return;
  };

  const [numPages, setNumPages] = useState(null);
  const [width, setWidth] = useState(700);
  const isPhone = useMediaQuery({ query: "(max-width: 550px)" });

  useEffect(() => {
    if (isPhone) {
      setWidth(400);
    }
  }, [isPhone]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <>
      <div className={styles.pdfModal}>
        <div
          className={styles.pdfModaOverlay}
          onClick={(e) => e.target === e.currentTarget && closeModal(e)}
        >
          <div className={styles.pdfModalContent}>
            <CloseIcon onClick={closeModal} className={styles.pdfClose} />
            <div className={styles.pdfViewerr}>
              <Document
                file={url}
                onLoadSuccess={onDocumentLoadSuccess}
                onPassword={handlePassword}
              >
                {Array.from(new Array(numPages), (_, index) => index + 1).map(
                  (pageNum) => (
                    <Page
                      key={pageNum}
                      pageNumber={pageNum}
                      className={pdfStyles.pdfStyle}
                      width={width}
                    />
                  )
                )}
              </Document>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PDFViewer;
